import type { TrackingEvent } from '@marketplace-web/shared/event-tracker-data'

type ConversationEventArgs = {
  transactionId: number | string
  conversationId: number | string
  userSide: string | null
  oppositeUserId: string | null
}

type ConversationEventExtra = {
  transaction_id: number | string
  conversation_id: number | string
  user_side: string | null
  opposite_user_id: string | null
}

export const conversationUserProfileIconClick = (args: ConversationEventArgs): TrackingEvent => {
  const { transactionId, conversationId, userSide, oppositeUserId } = args

  const extra: ConversationEventExtra = {
    transaction_id: transactionId,
    conversation_id: conversationId,
    user_side: userSide,
    opposite_user_id: oppositeUserId,
  }

  return {
    event: 'conversation.user_profile_icon_click',
    extra,
  }
}
